export default "__VITE_ASSET__CXYjXZxR__"